import type {
  GivingAccountAdmin,
  GivingAccountAdminResponse,
  GivingAccountReview,
  GivingAccountReviewResponse,
} from '../types';

export function mapGivingAccountAdmin(data: GivingAccountAdminResponse): GivingAccountAdmin {
  return {
    id: data.id,
    organization: data.organization
      ? {
          id: data.organization.id,
          name: data.organization.name,
          handle: data.organization.handle,
          image: data.organization.image,
        }
      : null,
    status: data.status,
    paymentsEnabled: data.payments_enabled,
    payoutsEnabled: data.payouts_enabled,
    manualReviewStatus: data.manual_review_status,
    reviewerName: data.reviewer_name,
    reviewerNote: data.reviewer_note,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
}

export function mapGivingAccountReview(data: GivingAccountReviewResponse): GivingAccountReview {
  return {
    id: data.id,
    manualReviewStatus: data.manual_review_status,
    reviewerName: data.reviewer_name,
    reviewerNote: data.reviewer_note,
    updatedAt: data.updated_at,
  };
}
